export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ22.83f6c00d.mp3";